// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e1675cb9","40":"4f98db41","80":"2d96b581","112":"42f054ea","156":"542f517a","441":"3817b8c6","592":"2290df34","620":"4862e12e","632":"d341dac5","664":"cdc1dd7c","672":"6ab0610e","792":"497de579","872":"b0abf2af","888":"e0a06f9c","936":"fa5e0996"}[chunkId] + ".chunk.js";
};